import { FC } from 'react';
import { useStyles } from './styles';
import { RecoveryRequestForm } from 'components/Forms';
import { ReactComponent as LogoIcon } from 'assets/logo.svg';

const AdminForgotPassword: FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.topBar}>
        <LogoIcon style={{ marginLeft: '40px', width: '140px', height: '52px' }} className={classes.logo} />
      </div>
      <RecoveryRequestForm type='admin-forgot-password' title='Reset Password' />
      {/* <div className={classes.footer}>
        <p>Copyright 2022 9STAR, All Rights Reserved. Version 0.1.39</p>
      </div> */}
    </div>
  );
};

export default AdminForgotPassword;
